import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { get as _get } from "lodash";

class AnalysisView extends Component {
  render() {
    const { reportData } = this.props;
    const analysis = _get(reportData, "sections.analysis", {});
    const kicker = _get(analysis, "kicker", "");
    const title = _get(analysis, "title", "");
    const intro = _get(analysis, "intro", "");
    const reportSections = _get(analysis, "report_sections", []);

    return (
      <div className="sa-tab-content">
        <div className="sa-report-doc">
          <span className="sa-report-doc__kicker">
            {kicker || (
              <FormattedMessage
                id="strategic_analysis.view_report.analysis.kicker"
                defaultMessage="Post-Campaign Report"
              />
            )}
          </span>
          <h2 className="sa-report-doc__title">
            {title || (
              <FormattedMessage
                id="strategic_analysis.view_report.analysis.title"
                defaultMessage="Lead Profiling & Sales Alignment Strategy"
              />
            )}
          </h2>
          <p className="sa-report-doc__intro">
            {intro || (
              <FormattedMessage
                id="strategic_analysis.view_report.analysis.intro"
                defaultMessage="Comprehensive analysis of generated pipeline data."
              />
            )}
          </p>

          <div className="row g-5">
            {reportSections.map((section, index) => (
              <div className="col-12" key={`section-${_get(section, "section_number", index)}`}>
                {_get(section, "kicker", "") && (
                  <p className="sa-report-doc__section-kicker">
                    {section.kicker}
                  </p>
                )}
                <h3 className="sa-report-doc__section-title">
                  {_get(section, "title", "")}
                </h3>
                <p className="sa-report-doc__body">
                  {_get(section, "summary", "")}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default AnalysisView;
